/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { PublicItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Download } from '../Download/Download';
import { ItemName } from '../ItemName/ItemName';
import { ItemTip } from '../ItemTip/ItemTip';
import { Pic } from '../Pic/Pic';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface PublicProps extends PublicItemProps {
    checkboxClassname?: string;
}

export const Public: FC<PublicProps> = (props) => {
    const { tipData, isFolder, checkboxClassname } = props;

    return (
        <>
            <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
            <TableColumn>
                <Checkbox className={checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    author={props.author}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Download
                    onClick={props.onDownload}
                    ext={props.isFolder ? 'zip' : props.ext}
                    size={props.size}
                    id={props.id}
                    storage={props.storage}
                />
            </TableColumn>
        </>
    );
};
